// A voice note with no usable text hides three different truths: the
// transcript is still on the way, the recording carried no recognizable
// speech, or the transcription failed. One dead "Hlasová poznámka" label
// covered all three and the audio itself was unplayable (night walk R22).
// Every render site derives the state here and offers the original
// recording whenever there is no text to read.
export type VoiceNoteState = "text" | "transcribing" | "noSpeech" | "failed" | "voiceOnly";

export function voiceNoteState(input: {
  text: string | null;
  hasAudio: boolean;
  transcriptStatus: string | null;
}): VoiceNoteState {
  if (input.text) return "text";
  if (!input.hasAudio) return "voiceOnly";
  if (input.transcriptStatus === "pending" || input.transcriptStatus === "processing") return "transcribing";
  if (input.transcriptStatus === "error") return "failed";
  return "noSpeech";
}

export const VOICE_NOTE_KEYS: Record<Exclude<VoiceNoteState, "text">, string> = {
  transcribing: "sales.notes.voiceTranscribing",
  noSpeech: "sales.notes.voiceNoSpeech",
  failed: "sales.notes.voiceFailed",
  voiceOnly: "sales.notes.voiceOnly"
};
